import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ChurchIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h10v-3h2v3h10v-8l-4-1.78zM11 20H4v-5.12L12 11.3l8 3.58V20h-7v-3h-2v3z" />
  </SvgIcon>
);

export default ChurchIcon;
